import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import Container from '../../../Container/Container';

import {
  TXTWCL_Complete_your_profile_to_join__ELL,
  TXTWCL_Final_Steps,
  TXTWCL_To_be_able_to_bet_at_the_poker_ELL,
  TXTWCL_Verify_your_ID_within_30_days__ELL,
  TXTWCL_YouXre_all_set,
  TXTWCL_Your_account_has_been_createdX_1
} from './RMFCompleted.messages.json';
import RMFCompletedAlert from './components/RMFCompletedAlert/RMFCompletedAlert';
import RMFCompletedButtonsGroup from './components/RMFCompletedButtonsGroup/RMFCompletedButtonsGroup';

const RMFCompleted: React.FC = () => {
  const isFrance = useSelector(select.cms.getSiteId) === Sites.FRA;

  return (
    <Container
      page={RMFCompleted}
      headerProps={{
        title: <Translation {...TXTWCL_Final_Steps} />,
        buttons: {}
      }}
      pageTopTitle={<Translation {...TXTWCL_YouXre_all_set} />}
      pageTopSubtitle={
        <>
          <Translation {...TXTWCL_Your_account_has_been_createdX_1} />{' '}
          <Translation {...TXTWCL_Complete_your_profile_to_join__ELL} />
        </>
      }
    >
      <div>
        <RMFCompletedAlert>
          {isFrance ? (
            <Translation {...TXTWCL_To_be_able_to_bet_at_the_poker_ELL} />
          ) : (
            <Translation {...TXTWCL_Verify_your_ID_within_30_days__ELL} />
          )}
        </RMFCompletedAlert>
        <RMFCompletedButtonsGroup />
      </div>
    </Container>
  );
};

RMFCompleted.displayName = 'RMFCompleted';

export default RMFCompleted;
